module.exports = __webpack_public_path__ + "media/audio6.ed1ca9b9.mp3";